export function sortUserOption(a, b) {
	return a.disabled - b.disabled || a.text.localeCompare(b.text);
}
